import styled, { css } from 'styled-components'

interface ContainerProps {
  open?: boolean
  hidden?: boolean
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  align-items: center;
  justify-content: center;

  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  z-index: 2000;

  background: rgba(0, 0, 0, 0.5);

  transition: transform 0.5s ease-in-out;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  transform: ${({ open }) => (open ? 'translateY(0)' : 'translateY(-100%)')};
`

export const Content = styled.div<ContainerProps>`
  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}

  width: 100%;
  height: auto;
  background-color: ${({ theme }) => `rgb(${theme.background.high})`};
  border: 2px solid #333;
  border-radius: 8px;
  padding: 1rem;

  @media only screen and (min-width: 600px) {
    max-width: 30vw;
    max-height: 80vh;
  }

  .imgLesson {
    img {
      margin: 0 auto;
      max-width: 70vw;
      max-height: 70vh;
      transition: transform 0.2s;
      cursor: pointer;
    }
  }
`

export const ButtonClose = styled.div`
  border: none;
  display: flex;
  justify-content: end;
  // position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  @media only screen and (min-width: 1080px) {
    top: 70px;
    right: 150px;
  }
`
